import React from "react";

// import MapShape2 from "../../assets/images/shape/map-shape2.png";
import analysis from "../../assets/images/salary/change/analysis.png";

const Change = () => {
  return (
    <section className="section bg-color pt-100 pb-70">
      <div className="container">
        <div className="section-title">
          <h2>人力成本分析</h2>
          <p>系统内置收入水平对比分析，人力成本分析，年度预算分析等多种分析方式，帮助企业找出低人效部门，统计不合理人力支出，调整人力方案</p>
        </div>

        <div className="d-flex w-100 justify-content-center">
          <img src={analysis} width="800" alt="人力成本分析" className="rounded" />
        </div>

        {/* <div className="row">
          <div className="col-lg-6 col-md-12">
            <div className="why-choose-us-content">
              <h2>人力成本分析</h2>
              <p>系统内置收入水平对比分析，人力成本分析，年度预算分析等多种分析方式，帮助企业找出低人效部门，统计不合理人力支出，调整人力方案</p>

              <div className="map-shape2">
                <img src={MapShape2} alt="年度人工成本核算分析" />
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-md-12">
            <div className="why-choose-us-content">
              <h2>年度人工成本预算分析</h2>
              <p>系统根据历年人力成本数据和人力需求，自动生成次年人力预算，业务部门仅需修改预算，降低工作量</p>
              <div className="map-shape2">
                <img src={MapShape2} alt="年度人工成本预算分析" />
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default Change;
